var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#373A36",
    fillRule: "evenodd",
    d: "M6.14.12a5.88 5.88 0 1 1 0 11.76 5.88 5.88 0 0 1 0-11.76m.018 7.86a.516.516 0 0 0 0 1.032.516.516 0 0 0 .517-.512.52.52 0 0 0-.517-.52m.133-4.705c-1.204 0-1.729.89-1.729 1.613q0 .213.047.378l.76.094a1.3 1.3 0 0 1-.056-.385c0-.496.298-1.007.978-1.007.626 0 .931.432.931.897 0 .307-.149.59-.414.77l-.345.237c-.461.315-.649.708-.649 1.228 0 .102 0 .18.008.275h.688c-.008-.079-.008-.11-.008-.15 0-.306.102-.59.345-.755l.36-.244c.453-.307.797-.74.797-1.37 0-.802-.618-1.58-1.713-1.58Z"
  })));
};
export default SvgQuestion;